export function initRouter (App) {
  App.config.router = {
    guards: {
      before: [],
      after: []
    },
    options: {
      routes: []
    }
  };

  // Provide a container for router methods
  App.router = {};

  // Add the ability to extend routes
  App.router.addRoutes = (routes) => {
    if (!Array.isArray(routes)) {
      routes = [routes];
    }

    App.config.router.options.routes.push(...routes);
  };

  App.router.configure = (options) => {
    Object.assign(App.config.router.options, options);
  };

  // Provide access to route guards
  App.router.beforeEach = (delegate) => {
    App.config.router.guards.before.push(delegate);
  };
  App.router.afterEach = (delegate) => {
    App.config.router.guards.after.push(delegate);
  };
}
